const colors = {
    white: '#fff',
    text: '#96969D',
    textDefault: '#131313',
    textBold: '#363639',
    orange: '#FFC63D',
    cardBackground: '#0000001A',
    border: '#ebebeb',
    icon: '#96969D',
    gray_90: '#111111',
    gray_70: '#58585B',
    gray_40: '#A9AAAC',
    gray_10: '#F4F4F5',
};

export default colors;
